// src/data/cards.js
// All request card definitions live here.
// Add, remove, or reorder cards by editing these arrays.

export const REQUEST_CARDS = [
  {
    id: 'afs-loans',
    title: 'AFS & Loans',
    description: 'Submit an AFS incident or raise a loan-related concern.',
    cta: 'Open request',
  },
  {
    id: 'system-issues',
    title: 'System Issues',
    description: 'Report a production bug or log a system incident.',
    cta: 'Open request',
  },
  {
    id: 'customer-experience',
    title: 'Customer Experience',
    description: 'Submit a report or complaint on behalf of a customer.',
    cta: 'Open request',
  },
  {
    id: 'access-request',
    title: 'Access Request',
    description: 'Request access to any of our systems, mailing lists and other resources.',
    cta: 'Open request',
  },
  {
    id: 'platform-request',
    title: 'Platform Request',
    description: 'Request a new installation, application, or service.',
    cta: 'Open request',
  },
  {
    id: 'general',
    title: 'General',
    description: 'Submit a suggestion or ask a question to the team.',
    cta: 'Open request',
  },
];
